const PrivacyPolicy = () => {
  return (
    <div className="w-full p-6">
      <div className="space-y-6 text-gray-700 leading-relaxed">
        <h1 className="text-2xl font-bold text-gray-900">
          Privacy Policy – Helacred
        </h1>

        <p>
          At <strong>Helacred</strong>, we respect your privacy and are
          committed to protecting your personal and financial information. This
          Privacy Policy explains how we collect, use, store, and safeguard your
          information when you engage with our credit services. By applying for
          or using our services, you consent to the practices outlined in this
          policy.
        </p>

        <h2 className="text-xl font-semibold text-gray-900">
          1. Information We Collect
        </h2>
        <p>
          We may collect the following categories of information when you use
          our services:
        </p>
        <ul className="list-disc list-inside space-y-1">
          <li>
            <strong>Personal Identification:</strong> Full name, date of birth,
            national ID or passport number, and contact details (phone number,
            email, address).
          </li>
          <li>
            <strong>Financial Information:</strong> Bank account details,
            employment status, income information, and credit history.
          </li>
          <li>
            <strong>Loan & Transaction Data:</strong> Loan applications,
            repayment history, outstanding balances, and transaction records.
          </li>
          <li>
            <strong>Digital Information:</strong> Device identifiers, IP
            addresses, and activity logs when using our digital platforms.
          </li>
          <li>
            <strong>Guarantor/Reference Information:</strong> Where applicable,
            details of guarantors or referees provided in loan applications.
          </li>
        </ul>

        <h2 className="text-xl font-semibold text-gray-900">
          2. How We Use Your Information
        </h2>
        <p>
          Your information is used to provide and improve our services,
          including:
        </p>
        <ul className="list-disc list-inside space-y-1">
          <li>Verifying your identity and eligibility for credit services.</li>
          <li>Assessing creditworthiness and determining loan approval.</li>
          <li>Managing your loan account and processing transactions.</li>
          <li>
            Communicating important updates, repayment reminders, or service
            changes.
          </li>
          <li>Complying with regulatory, legal, and audit requirements.</li>
          <li>
            Improving our digital platforms, customer support, and service
            delivery.
          </li>
        </ul>

        <h2 className="text-xl font-semibold text-gray-900">
          3. Sharing of Information
        </h2>
        <p>
          We do not sell or rent your personal data. However, we may share your
          information under the following circumstances:
        </p>
        <ul className="list-disc list-inside space-y-1">
          <li>
            <strong>Regulatory Authorities:</strong> Where disclosure is
            required by law, regulation, or legal process.
          </li>
          <li>
            <strong>Credit Reference Bureaus:</strong> To report credit
            performance, defaults, or outstanding obligations.
          </li>
          <li>
            <strong>Service Providers & Partners:</strong> Trusted third parties
            who assist in processing transactions, IT support, fraud prevention,
            or debt collection.
          </li>
          <li>
            <strong>Guarantors or Co-signers:</strong> Where necessary to
            enforce loan agreements.
          </li>
        </ul>

        <h2 className="text-xl font-semibold text-gray-900">
          4. Data Protection & Security
        </h2>
        <p>
          Helacred applies strict technical, administrative, and
          physical measures to protect your information against unauthorized
          access, loss, or misuse. While we take all reasonable precautions, no
          method of storage or transmission is 100% secure, and we cannot
          guarantee absolute security.
        </p>

        <h2 className="text-xl font-semibold text-gray-900">
          5. Data Retention
        </h2>
        <p>
          We retain your personal information only as long as it is necessary
          for the purposes stated in this policy, or as required by law,
          regulation, or internal policy. When data is no longer required, it
          will be securely deleted or anonymized.
        </p>

        <h2 className="text-xl font-semibold text-gray-900">6. Your Rights</h2>
        <p>As a client, you have the right to:</p>
        <ul className="list-disc list-inside space-y-1">
          <li>Request access to the personal data we hold about you.</li>
          <li>Request corrections to inaccurate or incomplete information.</li>
          <li>
            Request deletion of your data, subject to legal or contractual
            obligations.
          </li>
          <li>Withdraw consent for data processing, where applicable.</li>
          <li>Object to the use of your data for direct marketing purposes.</li>
        </ul>

        <h2 className="text-xl font-semibold text-gray-900">
          7. Cookies & Digital Tracking
        </h2>
        <p>
          When using our website or mobile platforms, we may use cookies and
          similar technologies to enhance your experience, track usage patterns,
          and improve service delivery. You can control cookie preferences
          through your browser settings.
        </p>

        <h2 className="text-xl font-semibold text-gray-900">
          8. Policy Updates
        </h2>
        <p>
          Helacred reserves the right to update or modify this Privacy
          Policy from time to time. Any significant changes will be communicated
          through our official communication channels. Continued use of our
          services after changes implies acceptance of the updated policy.
        </p>

        <h2 className="text-xl font-semibold text-gray-900">9. Contact Us</h2>
        <p>
          If you have any questions, requests, or complaints regarding this
          Privacy Policy or the handling of your data, please contact us:
        </p>
        <ul className="list-disc list-inside space-y-1">
          <li>
            <strong>Email:</strong> privacy@helacred.com
          </li>
          <li>
            <strong>Phone:</strong> +254-700-000-000
          </li>
          <li>
            <strong>Office Address:</strong> Helacred Headquarters,
            Nairobi, Kenya
          </li>
        </ul>

        <p className="mt-6">
          By engaging with <strong>Helacred</strong> services, you
          acknowledge that you have read, understood, and agreed to this Privacy
          Policy.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
